<template>
  <!-- 重点区域 -->
  <div class="user-list">
    <div class="page-head">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>日志管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="table-form">
      <el-form :inline="true" label-position="left" size="mini">
        <el-form-item label="" :label-width="formLabelWidth">
          <el-date-picker
            v-model="day"
            type="daterange"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="mini"
            style="width: 280px;margin-right: 10px"
            @change="dayChange"
          >
          </el-date-picker>
          <el-input
            v-model="lookfor.username"
            style="width: 150px;margin-right: 10px"
            clearable
            placeholder="请输入操作人账号"
          >
          </el-input>
          <el-select
            v-model="lookfor.city"
            placeholder="市"
            :label-in-value="true"
            clearable
            @change="selectChangee"
            style="width:90px"
            :disabled="noSelectCity"
          >
            <el-option
              v-for="item in options"
              :key="item.code"
              :id="item.id"
              :codeLevel="item.code_level"
              :code="item.code"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
          <el-select
            v-model="lookfor.county"
            placeholder="区县"
            :label-in-value="true"
            clearable
            @change="selectChangeCounty"
            style="width:90px"
            :disabled="noSelectCounty"
          >
            <el-option
              v-for="item in optionsCounty"
              :key="item.code"
              :id="item.id"
              :codeLevel="item.code_level"
              :code="item.code"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
          <el-select
            v-model="lookfor.town"
            placeholder="乡镇"
            :label-in-value="true"
            clearable
            @change="selectChangeTown"
            style="width:120px"
            :disabled="noSelectTown"
          >
            <el-option
              v-for="item in optionsTown"
              :key="item.code"
              :id="item.id"
              :codeLevel="item.code_level"
              :code="item.code"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
          <el-select
            v-model="lookfor.village"
            placeholder="村或居委会"
            :label-in-value="true"
            clearable
            @change="selectChangeVillage"
            style="width:120px"
            :disabled="noSelectVillage"
          >
            <el-option
              v-for="item in optionsVillage"
              :key="item.code"
              :id="item.id"
              :codeLevel="item.code_level"
              :code="item.code"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
          <el-select
            v-model="lookfor.dataType"
            placeholder="所属范围"
            :label-in-value="true"
            style="width:120px"
            clearable
            @change="getType"
          >
            <el-option
              v-for="item in optionsRange"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-select
            v-model="lookfor.operationType"
            placeholder="操作类型"
            :label-in-value="true"
            style="width:120px"
            clearable
          >
            <el-option
              v-for="item in optionsOperationType"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-select
            v-model="lookfor.level"
            placeholder="账号级别"
            :label-in-value="true"
            style="width:120px"
            clearable
          >
            <el-option
              v-for="item in optionsAccountLevel"
              :key="item[0]"
              :label="item[1]"
              :value="item[0]"
            ></el-option>
          </el-select>
          <el-select
            v-model="lookfor.client"
            placeholder="系统类型"
            :label-in-value="true"
            style="width:120px"
            clearable
          >
            <el-option
              v-for="item in optionsSysType"
              :key="item[0]"
              :label="item[1]"
              :value="item[0]"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" @click="look_For()">搜索</el-button>
          <el-button type="primary" @click="downLoad()">下载</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-container">
      <el-table :data="userList" border="" stripe>
        <el-table-column
          show-overflow-tooltip
          type="index"
          label="序号"
          width="60"
          align="center"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="username"
          min-width="80"
          label="账号"
          align="center"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="name"
          min-width="80"
          label="姓名"
          align="center"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="organization"
          min-width="100"
          label="单位"
          align="center"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="position"
          min-width="80"
          label="职务"
          align="center"
        ></el-table-column>

        <el-table-column
          show-overflow-tooltip
          min-width="180"
          label="归属地"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.location }}</span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          min-width="120"
          label="账号级别"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ optionsAccountLevel.get(scope.row.level) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="ip"
          min-width="120"
          label="IP地址"
          align="center"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="dataTypeName"
          min-width="160"
          label="所属范围"
          align="center"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="operationTypeName"
          min-width="160"
          label="操作类型"
          align="center"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="content"
          min-width="180"
          label="操作内容"
          align="center"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          min-width="120"
          label="系统类型"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ optionsSysType.get(scope.row.client) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="time"
          min-width="180"
          label="操作时间"
          align="center"
        ></el-table-column>
      </el-table>
      <el-pagination
        background=""
        class="table-pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
import moment from 'moment'
Vue.use(Viewer);
export default {
  name: "UserList",
  components: {},
  data() {
    return {
      formLabelWidth: "150px",
      editFileList: [],
      basicUrl: null,
      level: "",
      noSelectCity: false,
      noSelectCounty: false,
      noSelectTown: false,
      noSelectVillage: false,
      options: [],
      optionsCounty: [],
      optionsTown: [],
      optionsVillage: [],
      cityName: "",
      countyName: "",
      townName: "",
      villageName: "",
      optionsRange: [],
        // new Map([
        // [1, '车辆管理'],
        // [2, '收集点管理'],
        // [3, '转运站管理'],
        // [4, '终端处理厂'],
        // [5, '设备管理'],
        // [6, '重点区域']
      // ]),
      optionsRangeJson: {},
      optionsOperationType: [],
        // new Map([
        // [1, '新增'],
        // [2, '删除'],
        // [3, '编辑'],
        // [4, '审核'],
        // [5, '锁定'],
        // [6, '解锁'],
        // [7, '设备绑定'],
        // [8, '下载']
      // ]),
      optionsOperationTypeJson: {},
      optionsAccountLevel: new Map([
        [1, '省级账号'],
        [2, '市级账号'],
        [3, '县级账号'],
        [4, '乡镇级账号'],
        [5, '村级账号']
      ]),
      optionsSysType: new Map([
        [0, '管理后台'],
        [1, '手机APP']
      ]),
      day: [],
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          if (minDate && this.pickerMinDate) {
            this.pickerMinDate = null;
          } else if (minDate) {
            this.pickerMinDate = minDate;
          }
        },
        disabledDate: (time) => {
          if (this.pickerMinDate) {
            let maxTime = moment(this.pickerMinDate).add(180, 'days')
            let minTime = moment(this.pickerMinDate).subtract(180, 'days')
            return moment(time).isBefore(moment(minTime)) || moment(time).isAfter(moment(maxTime)) || moment(time).isAfter(moment())
          } else {
            return moment(time).isAfter(moment())
          }
        },
      },
      lookfor: {
        provice: 520000000000,
        city: null,
        county: null,
        town: null,
        village: null,
      },
      page: 1,
      pageSize: 10,
      totalCount: 0,
      userList: [],
    };
  },
  computed: {},
  created() {
    this.level = sessionStorage.getItem('level')
    if (this.level == 2) {
      this.lookfor.city = sessionStorage.getItem('user_city')
      this.getCountyOptions(this.lookfor.city)
      this.noSelectCity = true
    } else if (this.level == 3) {
      this.lookfor.city = sessionStorage.getItem('user_city')
      this.lookfor.county = sessionStorage.getItem('user_county')
      this.getCountyOptions(this.lookfor.city)
      this.getTownOptions(this.lookfor.county)
      this.noSelectCity = true
      this.noSelectCounty = true
    } else if (this.level == 4) {
      this.lookfor.city = sessionStorage.getItem('user_city')
      this.lookfor.county = sessionStorage.getItem('user_county')
      this.lookfor.town = sessionStorage.getItem('user_town')
      this.getCountyOptions(this.lookfor.city)
      this.getTownOptions(this.lookfor.county)
      this.getVillageOptions(this.lookfor.town)
      this.noSelectCity = true
      this.noSelectCounty = true
      this.noSelectTown = true
    } else if (this.level == 5) {
      this.lookfor.city = sessionStorage.getItem('user_city')
      this.lookfor.county = sessionStorage.getItem('user_county')
      this.lookfor.town = sessionStorage.getItem('user_town')
      this.lookfor.town = sessionStorage.getItem('user_village')
      this.getCountyOptions(this.lookfor.city)
      this.getTownOptions(this.lookfor.county)
      this.getVillageOptions(this.lookfor.town)
      this.noSelectCity = true
      this.noSelectCounty = true
      this.noSelectTown = true
      this.noSelectVillage = true
    }
    this.getUserList();
    this.getOptions();
    this.getRange()
  },
  mounted() {},
  methods: {
    dayChange(val) {
      if (val && val.length > 0) {
        this.lookfor.startTime = val[0]
        this.lookfor.endTime = val[1]
      } else {
        this.lookfor.startTime = ''
        this.lookfor.endTime = ''
      }
    },
    getOptions() {
      var data = {};
      if (this.value) {
        data = { code: this.value };
      } else {
        data = { code: 520000000000 };
      }
      this.$request.get("/village/type/getChildInfo", data).then((response) => {
        this.options = response.data;
      });
    },
    getRange() {
      let data = {
        level: 2,
        parentId: 1
      }
      this.$request.get("/village/operationLog/getOperationType", data).then((response) => {
        this.optionsRange = response.data;
      });
    },
    getType(val) {
      if (val) {
        let params = {
          level: 3,
          parentId: val
        }
        this.$request.get("/village/operationLog/getOperationType", params).then((response) => {
          this.optionsOperationType = response.data;
        });
      } else {
        this.lookfor.operationType = ''
        this.optionsOperationType = []
      }
    },
    getCountyOptions(val) {
      if (val) {
        var data = {};
        data = { code: val };
        this.$request
          .get("/village/type/getChildInfo", data)
          .then((response) => {
            this.optionsCounty = response.data;
          });
      } else {
        this.getUserList();
      }
    },
    getTownOptions(val) {
      if (val) {
        var data = {};
        data = { code: val };
        this.$request
          .get("/village/type/getChildInfo", data)
          .then((response) => {
            this.optionsTown = response.data;
          });
      }
    },
    getVillageOptions(val) {
      if (val) {
        var data = {};
        data = { code: val };
        this.$request
          .get("/village/type/getChildInfo", data)
          .then((response) => {
            this.optionsVillage = response.data;
          });
      }
    },
    selectChangee(val, codeLevel) {
      if (val) {
        for (var i in this.options) {
          if (this.options[i].code == val) {
            this.cityName = this.options[i].name;
          }
        }
      }
      this.lookfor.county = "";
      this.lookfor.town = "";
      this.lookfor.village = "";
      this.getCountyOptions(val);
    },
    selectChangeCounty(val, codeLevel) {
      if (val) {
        for (var i in this.optionsCounty) {
          if (this.optionsCounty[i].code == val) {
            this.countyName = this.optionsCounty[i].name;
          }
        }
      }
      this.getTownOptions(val);
      this.lookfor.town = "";
      this.lookfor.village = "";
    },
    selectChangeTown(val, codeLevel) {
      if (val) {
        for (var i in this.optionsTown) {
          if (this.optionsTown[i].code == val) {
            this.townName = this.optionsTown[i].name;
          }
        }
      }
      this.getVillageOptions(val);
      this.lookfor.village = "";
    },
    selectChangeVillage(val, codeLevel) {
      if (val) {
        for (var i in this.optionsVillage) {
          if (this.optionsVillage[i].code == val) {
            this.villageName = this.optionsVillage[i].name;
          }
        }
      }
    },
    look_For() {
      this.page = 1
      this.getUserList()
    },
    getUserList() {
      let look_for = {};
      for (let index in this.lookfor) {
        if (this.lookfor[index]) {
          look_for[index] = this.lookfor[index];
        }
      }
      look_for.pageNo = this.page
      look_for.pageSize = this.pageSize
      this.$request
        .get("/village/operationLog/list", look_for)
        .then((response) => {
          this.userList = [];
          this.userList = response.data.rows;
          this.totalCount = response.data.total;
          this.userList.forEach(el => {
            let location = el.provinceName + el.cityName + el.countyName + el.townName + el.villageName
            el.location = location.replace(/null/g, '')
            el.time = this.formatDate(new Date(el.time))
          })
        });
    },
    formatDate(now) {
        var year = now.getFullYear(); //取得4位数的年份
        var month = this.addzoer(now.getMonth() + 1); //取得日期中的月份，其中0表示1月，11表示12月
        var date = this.addzoer(now.getDate()); //返回日期月份中的天数（1到31）
        var hour = this.addzoer(now.getHours()); //返回日期中的小时数（0到23）
        var minute = this.addzoer(now.getMinutes()); //返回日期中的分钟数（0到59）
        var second = this.addzoer(now.getSeconds()); //返回日期中的秒数（0到59）
        return year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
    },
    //定义函数判断时间小于十前面加0
    addzoer(timE) {
        if (timE < 10) {
            return '0' + timE
        } else {
            return timE
        }
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.page = 1;
      this.getUserList();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.getUserList();
    },
    // 下载
    downLoad () {
      delete this.lookfor.pageNo;
      delete this.lookfor.pageSize;
      console.log("lookfor", this.lookfor);
      this.$request
        .get4("/village/operationLog/export",this.lookfor)
        .then((response) => {
          if (response.code === 1) {
            const hrefLocation = response.data;
            console.log("hrefLocation", hrefLocation);
            window.location.href = hrefLocation;
          }
        });
    },
  },
};
</script>
<style lang="scss">
.user-list {
  & .table-container {
    & .table-pagination {
      margin: 20px 0;
    }
  }
}
.v-modal {
  z-index: 1201 !important;
}
// .detailsImg{
//   width: 150px;
//   height: 150px;
//   float: left;
//   margin: 0 10px 10px 0;
// }
.viewer-container {
  z-index: 2050 !important;
}
.viewer-canvas {
  z-index: 99999 !important;
}
</style>
